/** @format */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import idx from 'idx';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Table } from 'semantic-ui-react';
import { fetchGatewaysSharedWith } from '../../actions/gateways';
import { userHasRole } from '../../lib/auth';
import { EMPTY_TABLE_MESSAGE } from '../../lib/utilities';
import { PAGES_PATH } from '../../lib/variables';

const mapStateToProps = state => ({
  gatewaysSharedWith: state.gatewaysSharedWith,
});

const mapDispatchToProps = dispatch => ({
  fetchGatewaysSharedWith: (params = { qs: '' }) => {
    dispatch(fetchGatewaysSharedWith(params));
  },
});

class GatewaySharedWithTableComponent extends Component {
  componentDidMount() {
    const { gatewayId } = this.props;
    if (gatewayId) {
      this.props.fetchGatewaysSharedWith({
        qs: `gid=${gatewayId}&limit=1000`,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { gatewayId } = this.props;
    if (gatewayId && gatewayId !== prevProps.gatewayId) {
      this.props.fetchGatewaysSharedWith({
        qs: `gid=${gatewayId}&limit=1000`,
      });
    }
  }

  render() {
    const { gatewaysSharedWith } = this.props;

    return (
      <Fragment>
        {gatewaysSharedWith.rows && gatewaysSharedWith.rows.length > 0 ? (
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Label</Table.HeaderCell>
                <Table.HeaderCell>Sharing</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {idx(gatewaysSharedWith, accessory =>
                accessory.rows.map(row => (
                  <Table.Row key={`row-${row.id}`}>
                    <Table.Cell key={`row-${row.id}-label`}>
                      <Link
                        to={`${PAGES_PATH}/gateway/${idx(
                          row,
                          _ => _.gateway.id,
                        )}`}
                      >
                        <strong>{idx(row, _ => _.label) || 'no name'}</strong>
                      </Link>
                    </Table.Cell>

                    <Table.Cell key={`row-${row.id}-sharing`}>
                      {userHasRole('admin') ? (
                        <>
                          <Link to={`${PAGES_PATH}/user/${row.gateway.owner.id}`}>
                            {idx(row, _ => _.gateway.owner.username)}
                            <FontAwesomeIcon
                              icon="arrow-right"
                              className="icon"
                            />{' '}
                          </Link>
                          <Link to={`${PAGES_PATH}/user/${row.guest.id}`}>
                            {idx(row, _ => _.guest.username)}
                          </Link>
                        </>
                      ) : (
                        <>
                          {idx(row, _ => _.gateway.owner.username)}{' '}
                          <FontAwesomeIcon
                            icon="arrow-right"
                            className="icon"
                          />{' '}
                          {idx(row, _ => _.guest.username)}
                        </>
                      )}
                    </Table.Cell>
                  </Table.Row>
                )),
              )}
            </Table.Body>
          </Table>
        ) : (
          EMPTY_TABLE_MESSAGE
        )}
      </Fragment>
    );
  }
}

GatewaySharedWithTableComponent.propTypes = {
  gatewayId: PropTypes.string.isRequired,
  gatewaysSharedWith: PropTypes.object,
  fetchGatewaysSharedWith: PropTypes.func,
};

const GatewaySharedWithTable = connect(
  mapStateToProps,
  mapDispatchToProps,
)(GatewaySharedWithTableComponent);

export { GatewaySharedWithTable };
